/**
 * @description : Display item state, progress, details and history.
 * @requires {Object} applicationModel
 * @requires {Object} configService
 * @requires {Object} trackingService
 * @requires {Object} parcelsService
 * @requires {Object} tealiumService
 * @requires {Object} numberService
 * @requires {Function} $interpolate
 * @requires {Object} $cookies
 * @requires {Object} $window
 * @requires {Object} $filter
 * @requires {Function} $timeout
 */
function trackingResultsController(
  applicationModel,
  configService,
  trackingService,
  parcelsService,
  tealiumService,
  numberService,
  $interpolate,
  $cookies,
  $window,
  $filter,
  $timeout
) {

  const vm = this;
  let tooltip = null;
  let imgHolder = null;
  let counter = 0;
  vm.imageSrc = '';
  vm.hidePrintButton = false;
  vm.hideRotateButton = false;
  const monthsArr = configService.messages.tracking_results.months.split(',');
  const daysArr = configService.messages.tracking_results.days.split(',');
  // This only serves as a reference ordered index to map the weekdays for every other language.
  const weekDayArr = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  /**
   * @description : Convert date/time in UTC
   * @param {Object} dateToConvert
   * @returns {Object}
   */
  function calcTime(dateToConvert) {

    let offset = '0';
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const lastDayMarch = new Date(currentYear, 3, 0);
    const lastSundayMarch = new Date(
      lastDayMarch.setDate(
        lastDayMarch.getDate() - (lastDayMarch.getDay() === 0 ? 7 : lastDayMarch.getDay())
      )
    );
    const lastDayOct = new Date(currentYear, 10, 0);
    const lastSundayOct = new Date(
      lastDayOct.setDate(
        lastDayOct.getDate() - (lastDayOct.getDay() === 0 ? 7 : lastDayOct.getDay())
      )
    );

    // Offset will be +1 if current date falls within BST
    if (currentDate >= lastSundayMarch && currentDate <= lastSundayOct) {

      offset = '+1';

    }

    // Get UTC time in msec
    const utc0 = dateToConvert.getTime() + (dateToConvert.getTimezoneOffset() * 60000);

    // Create new Date object using supplied offset.
    const nd = new Date(utc0 + (3600000 * offset));

    return nd;

  }

  /**
   * @description : Check for inclusion & exclusion date/time.
   * @param {Array} schedule
   * @returns {Boolean}
   */
  function checkScheduleInclusionExclusion(schedule) {

    const today = (calcTime(new Date()));

    for (let i = 0; i < schedule.length; i++) {

      // Set the date/time as require to validate against current date/time.
      let dateStartTimeObject = new Date(schedule[i].exceptionDate);
      let dateEndTimeObject = new Date(schedule[i].exceptionDate);
      dateStartTimeObject.setHours(
        parseInt(schedule[i].startTime.substr(0, 2), 10),
        parseInt(schedule[i].startTime.substr(3, 2), 10)
      );
      dateEndTimeObject.setHours(
        parseInt(schedule[i].endTime.substr(0, 2), 10),
        parseInt(schedule[i].endTime.substr(3, 2), 10)
      );

      dateStartTimeObject = calcTime(dateStartTimeObject);
      dateEndTimeObject = calcTime(dateEndTimeObject);

      // "inclusions": [{"exceptionDate": "2018-11-23", "startTime":"07:00", "endTime":"22:30"}]
      // If current date/time falls under inclusion start & end date/time,
      // then display chatbot window.

      // "exclusions": [
      //   {"exceptionDate": "2018-11-20", "startTime":"08:00", "endTime":"17:30"}
      //   {"exceptionDate": "2018-12-25", "startTime":"08:00", "endTime":"19:30"}
      // ]

      // If current date/time doesn't fall under exclusions defined date/time,
      // then display chatbot.
      // e.g. If current date/time is 2018-11-20 / 18:00pm which doesn't fall under
      // defined exclusions as {"exceptionDate": "2018-11-20", "startTime":"08:00", "endTime":"17:30"}
      // then display chatbot window.

      if (today >= dateStartTimeObject && today <= dateEndTimeObject) {

        return true;

      }

    }

    return false;

  }

  /**
   * @description : Check operating hours for chatbot.
   * @param {Object} chatbotWidgetOpHours
   * @returns {Integer}
   */
  function displayChatbotOpHours(chatbotWidgetOpHours) {

    let displayChatbot = false;
    let today = new Date();
    const day = weekDayArr[today.getDay()];

    // Create date objects and set the time as require.
    let startTimeObject = new Date(today);
    let endTimeObject = new Date(today);

    // Convert to require timezone.
    today = calcTime(today);
    startTimeObject = calcTime(startTimeObject);
    endTimeObject = calcTime(endTimeObject);

    // Loop through JSON array.
    /*eslint-disable */
    angular.forEach(chatbotWidgetOpHours.operatingSchedules.schedule, function (value, index) {

      // Check for inclusion dates.

      // "inclusions": [{"exceptionDate": "2018-11-23", "startTime":"07:00", "endTime":"22:30"}]
      // If current date/time falls under inclusion start & end date/time,
      // then display chatbot window.

      displayChatbot = checkScheduleInclusionExclusion(
        chatbotWidgetOpHours.operatingSchedules.schedule[index].inclusions
      );

      if (!displayChatbot) {

        // Check for normal days excluding date/time in exclusions.
        // "operatingHours": [
        // {"dayOfWeek":"Monday", "startTime":"08:00", "endTime":"19:30" },
        // {"dayOfWeek":"Tuesday", "startTime":"08:00", "endTime":"19:30" }]
        // "exclusions": [
        //   {"exceptionDate": "2018-11-20", "startTime":"08:00", "endTime":"17:30"}
        //   {"exceptionDate": "2018-12-25", "startTime":"08:00", "endTime":"19:30"}
        // ]

        // e.g. If current day is "Tuesday" with operating hours as 8:00am to 19:30pm
        // & exclusion has current date (2018-11-20) which falls on "Tuesday"
        // with operating hours as 8:00am to 17:30pm.
        // Then chatbot window should be displayed only within 17:30pm to 19:30pm on
        // date 2018-11-20.

        const opHours = chatbotWidgetOpHours.operatingSchedules.schedule[index].operatingHours;
        for (let i = 0; i < opHours.length; i++) {

          // Set the date/time as require to validate against current date/time.
          startTimeObject.setHours(
            parseInt(opHours[i].startTime.substr(0, 2), 10),
            parseInt(opHours[i].startTime.substr(3, 2), 10)
          );
          endTimeObject.setHours(
            parseInt(opHours[i].endTime.substr(0, 2), 10),
            parseInt(opHours[i].endTime.substr(3, 2), 10)
          );

          // If current day falls under normal days defined hours,
          // then display chatbot.

          // e.g If current day is "Monday" & current time is 9:00 am which
          // falls under the defined operating hours as
          // {"dayOfWeek":"Monday", "startTime":"08:00", "endTime":"19:30" }

          if (day === opHours[i].dayOfWeek && today >= startTimeObject && today <= endTimeObject) {

            displayChatbot = true;
            break;

          }

        }

        if (displayChatbot) {

          // Check for excluded date.

          // "exclusions": [
          //   {"exceptionDate": "2018-11-20", "startTime":"08:00", "endTime":"17:30"}
          //   {"exceptionDate": "2018-12-25", "startTime":"08:00", "endTime":"19:30"}
          // ]

          // If current date/time doesn't fall under exclusions defined date/time,
          // then display chatbot.
          // e.g. If current date/time is 2018-11-20 / 18:00pm which doesn't fall under
          // defined exclusions as {"exceptionDate": "2018-11-20", "startTime":"08:00", "endTime":"17:30"}
          // then display chatbot window.

          displayChatbot = !checkScheduleInclusionExclusion(
            chatbotWidgetOpHours.operatingSchedules.schedule[index].exclusions
          );

        }

      }

    });
    /*eslint-disable */

    return displayChatbot;

  }

  if (angular.isDefined(applicationModel.trackingDetails.mailPieces)) {

    const chatbotFrequency = configService.chatbot.chatbotFrequency;
    const chatbotWidgetLibURL = configService.chatbot.chatbotWidgetLibURL;
    const chatbotWidgetTimeDelay = configService.chatbot.chatbotTimeDelay;
    const chatbotWidgetOpJson = configService.chatbot.chatbotWidgetOpJson;
    let chatbotInServicePeriod = false;

    // Check if current date/time falls under chatbot configured operating hours.
    if (chatbotWidgetOpJson) {

      const chatbotWidgetOpHours = angular.fromJson(chatbotWidgetOpJson);
      chatbotInServicePeriod = displayChatbotOpHours(chatbotWidgetOpHours);

    }

    if ((parseInt(chatbotFrequency, 10) === 1 || (Math.random() < chatbotFrequency))
      && chatbotInServicePeriod === true) {

      if (!document.getElementById('flmntChatbot')) {

        // Show chatbot after a delay of 20 seconds.
        $timeout(() => {

          const script = document.createElement('script');
          angular.element(document.body).append('<div id="flmnt-placeholder"></div>');
          const placeholder = document.getElementById('flmnt-placeholder');
          script.type = 'text/javascript';
          script.async = true;
          script.src = chatbotWidgetLibURL;
          placeholder.appendChild(script);

        }, chatbotWidgetTimeDelay);

      }

      /*eslint-disable */
      const eventDate = applicationModel.trackingDetails.mailPieces.summary.lastEventDateTime;
      const eventStatus = applicationModel.trackingDetails.mailPieces.summary.statusCategory;
      const eventSummary = applicationModel.trackingDetails.mailPieces.summary.summaryLine;
      const eventCode = applicationModel.trackingDetails.mailPieces.events[0].eventCode;
      angular.element(document.body).append('<div id="flmntWidgetInit" '
        + ' flmnt-proxy="' + configService.chatbot.chatbotWidgetProxyUrl + '"'
        + ' flmnt-widgettitle="' + configService.chatbot.chatbotWidgetTitle + '"'
        + ' flmnt-widgetplaceholder="' + configService.chatbot.chatbotWidgetPlaceholder + '"'
        + ' flmnt-widgeticonurl="' + configService.chatbot.chatbotWidgetIconUrl + '"'
        + ' flmnt-widgettab="' + configService.chatbot.chatbotWidgetTabTitle + '"'
        + ' flmnt-widgeterror="' + configService.chatbot.chatbotWidgetError + '"'
        + ' flmnt-widgeturl="' + configService.chatbot.chatbotWidgetURL + '"'
        + ' flmnt-trackingnumber="' + applicationModel.trackingDetails.mailPieces.mailPieceId + '"'
        + ' flmnt-trackingstatus="' + eventStatus + '"'
        + ' flmnt-trackingsummary="' + eventSummary + '"'
        + ' flmnt-trackingeventcode="' + eventCode + '"'
        + ' flmnt-trackingdate="' + eventDate + '"' + '></div>');
      /*eslint-disable */

    }

  }


  // Set tealiumService
  const persistentTags = {

    pageApplicationName: configService.tealium.app_name,
    pagePersona: configService.tealium.instance.toLowerCase(),
    pageLanguage: (document.documentElement.lang === 'en') ? 'en-gb' : document.documentElement.lang

  };

  $window.scrollTo(0, 0);

  tealiumService.setBaseTags(persistentTags);

  /**
   * @description : generates tealium tags for this page.
   * @param {Boolean} isLoggedIn
   * @param {Object} response : parcel item details.
   * @returns {Object}
   */
  function resultsPage(isLoggedIn, response = {}) {

    const cookie = $cookies.get('parcels_jwt');
    const JWT = parcelsService.decodeJWT(cookie);
    const breadCrumb = (parcelsService.isSet(configService, 'breadcrumbs')) ?
      JSON.parse(configService.breadcrumbs) : '';
    const now = parcelsService.formatDate(new Date());
    const isInflightEnabled = displayInflightOption();

    // Override default tags when redelivery option available.
    const step = isInflightEnabled ? 'Result with Delivery Options' : 'Result';

    const tags = {
      pageName:
        `${configService.tealium.site_prefix} >${configService.tealium.instance} >Track Your Items >${step}`,
      pageMenuTree: `${configService.tealium.instance}|Track Your Items|${step}`,
      pageApplicationStep: step,
      pageTemplate: 'Results Screen',
      pageBreadCrumb: (Array.isArray(breadCrumb) && breadCrumb.length > 1) ?
        breadCrumb.join('|') : breadCrumb.toString(),
      conversionID: parcelsService.isSet(response, 'mailPieceId'),
      conversionDate: now.date,
      conversionType: 'Tracking Result',
      conversionProduct: {
        productSKU: parcelsService.isSet(response, 'mailPieceId'),
        productCategory: 'Track and Trace',
        productQuantity: 1,
        productAttributes: {
          carrierName: parcelsService.isSet(response, 'carrierShortName'),
          serviceName: parcelsService.isSet(response.summary, 'productName'),
          countryCode: parcelsService.isSet(response.summary, 'destinationCountryCode'),
          originCountryCode: parcelsService.isSet(response.summary, 'originCountryCode'),
          itemStatus: parcelsService.isSet(response.summary, 'statusDescription'),
          itemStatusCode: parcelsService.isSet(response.summary, 'lastEventCode'),
          itemStatusEDW: parcelsService.isSet(response, 'estimatedDelivery') ? '1' : '0',
          mapStatus: '0'
        }
      }
    };

    const userTags = {
      visitorGUID: parcelsService.isSet(JWT, 'sub'),
      visitorEmail: parcelsService.isSet(JWT, 'email'),
      visitorSegment: parcelsService.isSet(JWT, 'visitorSegment'),
      visitorRMPPost: parcelsService.isSet(JWT, 'visitorRMPPost'),
      visitorRMPPhone: parcelsService.isSet(JWT, 'visitorRMPPhone'),
      visitorRMPEmail: parcelsService.isSet(JWT, 'visitorRMPEmail'),
      visitorRMPOther: parcelsService.isSet(JWT, 'visitorRMPOther')
    };

    if (isInflightEnabled) {

      tags.conversionProduct.productAttributes.changeDeliveryOptions = '1';
      tags.pageBreadCrumb = 'Home|Track Your Items|Result with Delivery Options';
      tags.pageAttributes = 'Choose Delivery Options';

    }

    if (isGPSOptionEnabled()) {
      
      const pageAttribute = isInflightEnabled ? `${tags.pageAttributes}|` : '';
      tags.pageAttributes = `${pageAttribute}Map available`;
      tags.conversionProduct.productAttributes.mapStatus = '1';

    }

    if (isLoggedIn) return angular.merge(tags, userTags);

    return tags;

  }

  /**
   * @description: Check if item has Signature in api response.
   * @returns  {Boolean}
   */
  // TODO : Remove after backword compatability in later version v3.x
  function hasSignature() {

    const hasElement = parcelsService.checkNested(vm.trackingDetails, 'links', 'signatureimage', 'href');
    return (hasElement && vm.trackingDetails.links.signatureimage.href !== '');

  }

  /**
   * @description: Check if item has image node in api response.
   * @returns  {Boolean}
   */
  function hasImage() {

    const hasElement = parcelsService.checkNested(vm.trackingDetails, 'links', 'image', 'href');
    return (hasElement && vm.trackingDetails.links.image.href !== '');

  }

  /**
   * @description: Check if item has deliveryChangeOptions node in response.
   * @returns {Boolean}
   */
  function hasDeliveryChangeOption() {

    const hasElemnt = parcelsService.checkNested(vm.trackingDetails, 'links', 'deliverychangeoption', 'href');
    return (hasElemnt && vm.trackingDetails.links.deliverychangeoption.href !== '');

  }

  /**
   * @description: Check if Parcelforce item.
   * @returns  {Boolean}
   */
  function isPFW() {

    return ('carrierShortName' in vm.trackingDetails) && vm.trackingDetails.carrierShortName === 'PFW';

  }

  /**
   * @description: Get the signature image.
   */
  function getSignatureImage() {

    return (hasImage()) ? vm.trackingDetails.links.image.href : vm.trackingDetails.links.signatureimage.href;

  }

  /**
   * @description : Convert/format dates to other languages (EEEE/d/MMMM) e.g. Dydd Llun 13 Medi.
   * @param {String} date A date string provided by the API as "2016-11-20T10:04:00+01:00".
   * @returns {String} date.
   */
  function convertDate(date) {

    // We use angular to format the date objects then translate the parts with vanilla JS.
    const formattedDate = $filter('date')(parcelsService.ignoreTimezone(date), 'EEEE d MMMM');
    const weekDay = formattedDate.split(' ')[0];
    const weekDayIndex = weekDayArr.indexOf(weekDay);
    const dateArray = date.substr(0, 10).split('-');
    const month = parseInt(dateArray[1], 10) - 1;
    const day = dateArray[2];

    return `${daysArr[weekDayIndex].trim()} ${day.trim()} ${monthsArr[month].trim()}`;

  }

  function getTrackingHistory() {

    const history = {};
    let count = 0;

    if (vm.trackingDetails && vm.trackingDetails.events) {

      vm.trackingDetails.events.forEach((msg) => {

        if (!Array.isArray(history[msg.eventDateTime])) history[msg.eventDateTime] = [];

        if (count === 0) history[msg.eventDateTime].isFirstDay = true;

        history[msg.eventDateTime].push(msg);
        count += 1;

      });
      return history;

    }

    return false;

  }

  function expandTrackingHistory() {

    vm.showExtendedHistory = !vm.showExtendedHistory;

  }

  function getToggleClass(state) {

    return state ? 'expanded' : 'collapsed';

  }
  /**
   * @description: Get rotation style for pod image.
   */
  function getRotationStyle() {

    if (vm.rotationAngle === '90deg' || vm.rotationAngle === '270deg') {

      vm.rotationStyle = {

        padding: '15px',
        'max-width': '95%',
        transform: `rotate(${vm.rotationAngle})`,
        '-webkit-transform': `rotate(${vm.rotationAngle})`,
        '-moz-transform': `rotate(${vm.rotationAngle})`,
        '-ms-transform': `rotate(${vm.rotationAngle})`,
        '-o-transform': `rotate(${vm.rotationAngle})`

      };

    } else {

      vm.rotationStyle = {

        'max-width': '95%',
        transform: `rotate(${vm.rotationAngle})`,
        '-webkit-transform': `rotate(${vm.rotationAngle})`,
        '-moz-transform': `rotate(${vm.rotationAngle})`,
        '-ms-transform': `rotate(${vm.rotationAngle})`,
        '-o-transform': `rotate(${vm.rotationAngle})`

      };

    }

  }

  /**
   * @description: Open print preview in new window.
   */
  function printPage() {

    getRotationStyle();
    $timeout(() => {

      const location = ((/\w#print\b/ig.test($window.location.hash)) ?
        window.location.href : `${$window.location.href}#print`);
      const innerContents = angular.element(document.querySelector('#printView'))[0].innerHTML;
      const printTitle = vm.configService.messages.pod_print.sub_header;
      const printWindow = $window.open(location, '_blank');
      printWindow.document.open();
      printWindow.document.write(`<html><head><meta charset="UTF-8"><title>${printTitle}
      </title></head><body onload="window.print()">${innerContents}</body></html>`);
      printWindow.document.close();
      printWindow.location = location;

    }, 10);

  }

  /**
   * @description: Sets the state for Extended Footer.
   * @param {Array|Boolean} trackingHistory : Tracking History is either false
   * or an array.
   * @returns {Boolean} : If the Extended Fotter should be shown.
   */
  function getExtendedFooterState(trackingHistory) {

    let state = false;

    // IE has an issue with empty Objects and Object.keys
    // so we will check if trackingHistory is false first.
    if (trackingHistory === false) {

      return state;

    } else if (Object.keys(trackingHistory).length > 1) {

      state = true;

    }

    return state;

  }

  /**
   * @description: Check if country code is UK.
   * @param {String} code : The country code.
   * @returns {Boolean} : If the code is UK or not.
   */
  function isUkCode(code) {

    return (code.trim() === 'GBR' || code.trim() === 'GB');

  }

  /**
   * @description: Check if Redelivery button should be displayed.
   * @returns {Boolean} : If the Redelivery button should be displayed.
   */
  function displayRedelivery() {

    return vm.trackingDetails
      && (vm.trackingDetails.summary.statusCategory === configService.api.status_cat_value_mapping.delivery_attempted)
      && vm.trackingDetails.summary.destinationCountryCode
      && isUkCode(vm.trackingDetails.summary.destinationCountryCode);

  }

  /**
   * @description: Check if Inflight redelivery option button should be displayed.
   * @returns {Boolean}: If the Inflight redelivery option should be displayed.
   */
  function displayInflightOption() {

    return hasDeliveryChangeOption() && vm.configService.misc.tracking_results_inflight_enabled;

  }

  /**
   * @description: Construct URL for inflight redelivery.
   * @returns: inflight redelivery landing page url.
   */
  function inflightUrl() {

    const url = `${vm.configService.messages.redelivery.inflight_url}?${vm.configService.messages.redelivery.query_param}=${vm.trackingDetails.mailPieceId}`;
    window.location.href = url;

  }

  /**
   * @description: Get the session token from the applicationModel
   * @returns {String} : the current session token.
   */
  function getRecaptchaSession() {

    return applicationModel.googleRecaptcha.sessionToken;

  }

  /**
   * @description : Check if image exist.
   * @return {Boolean}
   */
  function isImageExist() {

    imgHolder = angular.element(document.querySelector('#picture-blob-holder'));
    if (imgHolder.length > 0) {

      imgHolder = imgHolder[0].childNodes[1];
      return (imgHolder.nodeName === 'IMG');

    }
    return false;

  }

  /**
   * @description: Rotate image clockwise 90 degree on each click.
   */
  function rotateImage() {

    if (isImageExist()) {

      // Remove all classes applied to image object.
      imgHolder.classList.remove('rotate-90', 'rotate-180', 'rotate-270', 'rotate-360');
      // IE Fix: Setting classname of image to empty as IE is not removing class from classList.
      imgHolder.className = '';
      vm.rotationAngle = '0deg';
      // Calculate marging from image/signature to fit in container on rotation.
      const imgWidth = imgHolder.offsetWidth;
      const imgHeight = imgHolder.height;
      const imgMargin = (imgWidth > imgHeight ? (imgWidth - imgHeight) / 2 : 0);
      imgHolder.style.marginBottom = '0';
      imgHolder.style.marginTop = '0';
      counter += 1;
      switch (counter) {

        case 1:
          imgHolder.classList.add('rotate-90');
          imgHolder.style.marginBottom = `${imgMargin}px`;
          imgHolder.style.marginTop = `${imgMargin}px`;
          vm.rotationAngle = '90deg';
          break;
        case 2:
          imgHolder.classList.add('rotate-180');
          vm.rotationAngle = '180deg';
          break;
        case 3:
          imgHolder.classList.add('rotate-270');
          imgHolder.style.marginBottom = `${imgMargin}px`;
          imgHolder.style.marginTop = `${imgMargin}px`;
          vm.rotationAngle = '270deg';
          break;
        default:
          imgHolder.classList.add('rotate-360');
          counter = 0;
          break;

      }

    }

  }

  /**
   * @description : Display error in image place holder and hide print and rotate button.
   */
  function handleImageError() {

    const para = document.createElement('p');
    const node = document.createTextNode(configService.messages.tracking_results.pod_image_error);
    para.appendChild(node);
    angular.element(document.querySelector('#picture-blob-holder')).append(para);

    vm.hideRotateButton = true;
    vm.hidePrintButton = true;

  }

  /**
   * @description: Currently cookies are required to retrieve the signature,
   * but when a browser blocks third party cookies we must set
   * a header and retrieve the image via a get request and create an element to
   * append to the view.
   */
  function renderSignature() {

    // TODO remove deprecated x-recaptcha-session once APIm 3.2 is deployed.
    trackingService.getSignature(getSignatureImage(), {
      'x-recaptcha-session': getRecaptchaSession(),
      'X-RMG-API-Session': getRecaptchaSession()
    }).then((response) => {

      // Check if image blob  exist then add image.
      if (response.data.size > 0) {

        const img = document.createElement('img');
        img.onload = () => {

          $window.URL.revokeObjectURL(img.src);

        };

        img.src = window.URL.createObjectURL(response.data);
        vm.imageSrc = window.URL.createObjectURL(response.data);
        angular.element(document.querySelector('#picture-blob-holder')).append(img);

      } else {

        handleImageError();

      }

    }).catch(() => {

      handleImageError();

    });

  }

  /**
   * @description: Check if pod image exist and rendered on page.
   * @returns {Boolean}
   */
  function isImageRendered() {

    return (vm.imageSrc !== '' || vm.imageSrc !== undefined || vm.imageSrc !== null);

  }

  /**
   * @description: Show/hide buttons
   * @param {Boolean} isHidden
   * @return {Boolean}
   */
  function showButton(isHidden) {

    return vm.trackingDetails
      && (vm.trackingDetails.links.signatureimage || vm.trackingDetails.links.image)
      && !isHidden;

  }

  /**
   * @description: Check if the Start Estimate for EDW
   * @param {String} time : The startDate for the EDW
   * @returns {Boolean} : If we show the start window or not.
   */
  function hasValidStartEstimate(time) {

    if ($filter('formatTime')(time) === '12:00am' || $filter('formatTime')(time) === '00:00am') {

      return false;

    }

    return true;

  }

  /**
   * @description: Check if given date is future date.
   * @param {Date} edDate
   * @return {Boolean}
   */
  function isFutureDate(edDate) {

    const todayDate = new Date();
    const deliveryDate = new Date(edDate);
    return todayDate < deliveryDate;

  }

  /**
   * @description Custom predicted delivery date message.
   */
  function setPDDMessage() {

    if (!vm.estimatedDelivery || !vm.estimatedDelivery.date) {

      return '';

    }

    const futureDate = isFutureDate(vm.estimatedDelivery.date);
    let eddMessage = '';

    // Neither start time nor end time node present.
    const startEndTimeNodeNotPresent = !vm.estimatedDelivery.startOfEstimatedWindow &&
      !vm.estimatedDelivery.endOfEstimatedWindow;

    // Start and end time node with valid time.
    const validStartAndEndTime = !startEndTimeNodeNotPresent &&
      vm.hasValidStartEstimate(vm.estimatedDelivery.endOfEstimatedWindow) &&
      vm.hasValidStartEstimate(vm.estimatedDelivery.startOfEstimatedWindow);

    // Only end time node with valid time.
    const validEndTime = !startEndTimeNodeNotPresent &&
      vm.hasValidStartEstimate(vm.estimatedDelivery.endOfEstimatedWindow) &&
      !vm.hasValidStartEstimate(vm.estimatedDelivery.startOfEstimatedWindow);

    switch (futureDate) {

      case false:

        if (startEndTimeNodeNotPresent) {

          eddMessage = vm.configService.messages.summary_line_edw.no_start_end_text;

        } else if (validStartAndEndTime) {

          eddMessage = `${vm.configService.messages.summary_line_edw.initial_text}
           ${($filter('formatTime')(vm.estimatedDelivery.startOfEstimatedWindow))} -
           ${($filter('formatTime')(vm.estimatedDelivery.endOfEstimatedWindow))}`;

        } else if (validEndTime) {

          eddMessage = `${(vm.configService.messages.summary_line_edw.no_start_text)}
           ${($filter('formatTime')(vm.estimatedDelivery.endOfEstimatedWindow))}`;

        }

        break;

      case true:

        if (startEndTimeNodeNotPresent) {

          eddMessage = `${vm.configService.messages.summary_line_edw.future_start_end_text}
          ${$filter('date')(new Date(vm.estimatedDelivery.date),
            vm.configService.messages.summary_line_edw.date_format)}`;

        } else if (validStartAndEndTime) {

          eddMessage = `${vm.configService.messages.summary_line_edw.future_start_end_text}
          ${$filter('date')(new Date(vm.estimatedDelivery.date),
            vm.configService.messages.summary_line_edw.date_format)}
          ${vm.configService.messages.summary_line_edw.between}
          ${($filter('formatTime')(vm.estimatedDelivery.startOfEstimatedWindow))} -
          ${($filter('formatTime')(vm.estimatedDelivery.endOfEstimatedWindow))}`;

        } else if (validEndTime) {

          eddMessage = `${vm.configService.messages.summary_line_edw.future_start_end_text}
          ${$filter('date')(new Date(vm.estimatedDelivery.date),
            vm.configService.messages.summary_line_edw.date_format)}
          ${vm.configService.messages.summary_line_edw.by}
          ${($filter('formatTime')(vm.estimatedDelivery.endOfEstimatedWindow))}`;

        }

        break;

      default:

        eddMessage = '';

        break;

    }

    return eddMessage;

  }

  /**
   * @description: Toggle tooltip class.
   * @param {Boolean} : Is tooltip icon leftOffset near to left edge of screen.
   * @param {String} : Class name of css.
   */
  function toggleTooltipClass(leftOffset) {

    return leftOffset ? 'right-align-tooltip' : 'left-align-tooltip';

  }

  /**
   * @description: Assign class after calculating left offset of tooltip.
   */
  function assignClass() {

    tooltip = angular.element(document.querySelector('#app .icon-tooltip'));
    if (tooltip.length > 0) {

      tooltip = tooltip[0];
      // Calculate tooltip position is in left or right of middle of screen.
      const tooltipOffset = tooltip.offsetLeft < (document.body.offsetWidth / 2);
      tooltip.classList.remove('left-align-tooltip', 'right-align-tooltip');
      tooltip.classList.add(toggleTooltipClass(tooltipOffset));

    }

  }

  /**
   * @description: Attach event listeners for pointer devices e.g. iPad, pen tablets,...
   * so we can handle :hover actions with tap/touch.
   */
  function attachPointerEvents() {

    tooltip = angular.element(document.querySelector('#app .icon-tooltip'));

    function touchAdd() {

      tooltip.classList.add('icon-tooltip-hover');

    }

    function touchRemove() {

      tooltip.classList.remove('icon-tooltip-hover');

    }

    // Check if tooltip exists on screen.
    if (tooltip.length > 0) {

      tooltip = tooltip[0];

      // Check if pointer events are supported.
      if (window.PointerEvent) {

        // Add Pointer Event Listener.
        $window.document.addEventListener('pointerdown', touchAdd, true);
        $window.document.addEventListener('pointermove', touchAdd, true);
        $window.document.addEventListener('pointerup', touchRemove, true);

      } else if (window.TouchEvent) {

        // Add Touch Event Listener.
        $window.document.addEventListener('touchstart', touchAdd, true);
        $window.document.addEventListener('touchmove', touchAdd, true);
        $window.document.addEventListener('touchend', touchRemove, true);

      }

    }

  }

  // Add some fields of the Tracking Response to a global variable to allow
  // other elements on the page (e.g: Knowledge base widget)
  // to use the results.
  if (parcelsService.isSet(applicationModel.trackingDetails, 'mailPieces')) {

    $window.parcelsTrackingResponse = {
      statusCategory: parcelsService.isSet(applicationModel.trackingDetails.mailPieces.summary, 'statusCategory'),
      productName: parcelsService.isSet(applicationModel.trackingDetails.mailPieces.summary, 'productName'),
      productCategory: parcelsService.isSet(applicationModel.trackingDetails.mailPieces.summary, 'productCategory')
    };

  }

  /**
   * Checking of GPS map feature enabled or not
   * @returns {Boolean}
   */
  function isGPSOptionEnabled() {

    return (vm.configService.misc.tracking_results_gps_enabled &&
      parcelsService.checkNested(vm.trackingDetails, 'position', 'longitude') &&
      numberService.areValidCoordinates(
        vm.trackingDetails.position.latitude,
        vm.trackingDetails.position.longitude)
      );

  }

  // Assign tooltip class on page load.
  angular.element(document).ready(() => assignClass());
  applicationModel.urlRefresh = true;
  applicationModel.urlSearch = false;
  vm.trackingDetails = applicationModel.trackingDetails.mailPieces;
  vm.markdownToHTML = parcelsService.markdownToHTML;
  vm.estimatedDelivery = applicationModel.estimatedDelivery;
  vm.trackingHistory = getTrackingHistory();
  vm.showExtendedFooter = getExtendedFooterState(vm.trackingHistory);
  vm.showExtendedHistory = false;
  vm.expandTrackingHistory = expandTrackingHistory;
  vm.getToggleClass = getToggleClass;
  vm.printPage = printPage;
  vm.rotateImage = rotateImage;
  vm.hasSignature = hasSignature;
  vm.hasImage = hasImage;
  vm.isImageRendered = isImageRendered;
  vm.getSignatureImage = getSignatureImage;
  vm.showButton = showButton;
  vm.signatureImage = (hasSignature() || hasImage()) ? getSignatureImage() : false;
  vm.PFWLimitedHistory = configService.messages.pfw.limited_history;
  vm.parcelflown = configService.messages.parcelflown;
  vm.isPFW = isPFW;
  vm.trackingHistoryText = configService.messages.tracking_results;
  vm.configService = configService;
  vm.isLoggedIn = parcelsService.isValidCookie();
  vm.resultsPage = resultsPage;
  vm.isUkCode = isUkCode;
  vm.displayRedelivery = displayRedelivery;
  vm.displayInflightOption = displayInflightOption;
  vm.inflightUrl = inflightUrl;
  vm.convertDate = convertDate;
  vm.ignoreTimezone = parcelsService.ignoreTimezone;
  $timeout(() => attachPointerEvents(), 0);
  $timeout(() => $window.addEventListener('resize', assignClass, true), 0);
  vm.getRecaptchaSession = getRecaptchaSession;
  vm.renderSignature = renderSignature;
  vm.hasValidStartEstimate = hasValidStartEstimate;
  vm.isFutureDate = isFutureDate;
  vm.setPDDMessage = setPDDMessage;
  vm.isGPSOptionEnabled = isGPSOptionEnabled;

  // Send Tealium tags only if the API response has no errors.
  if (!applicationModel.urlRequest || !applicationModel.urlRequest.error) {
    const tags = resultsPage(vm.isLoggedIn, vm.trackingDetails);

    tealiumService.sendTags(tags);

  }

}

export default trackingResultsController;



// WEBPACK FOOTER //
// ./src/components/trackingresults/tracking-results.controller.js